import { createIsomorphicFn } from "@tanstack/react-start";

const getEnvFn = createIsomorphicFn()
  .server(() => {
    return { ...process.env, ...import.meta.env };
  })
  .client(() => import.meta.env);

export const getEnv = new Proxy({} as Record<string, string | undefined>, {
  get(_, name: string) {
    const env = getEnvFn();
    return env[name];
  },
});
